import { render, staticRenderFns } from "./ContractComments.vue?vue&type=template&id=de9c430c&scoped=true"
import script from "./ContractComments.vue?vue&type=script&lang=js"
export * from "./ContractComments.vue?vue&type=script&lang=js"
import style0 from "./ContractComments.vue?vue&type=style&index=0&id=de9c430c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9c430c",
  null
  
)

export default component.exports